import React, { createContext, useContext, useReducer } from "react";
import { inboundReducer } from "./reducer";

import { API, graphqlOperation } from "aws-amplify";
import { aisleByActiveByZoneBySortKey } from "../../../graphql/reloadyard/custom-queries";
import {
  getInboundShipmentMobile,
  inboundShipmentByStateByRailcarReduced,
} from "../../../graphql/inbound/custom-queries";
import { performUpdateInbound } from "../../../graphql/inbound/inboundCRUD";
import { performUpdateInventoryMini } from "../../../graphql/inventory/inventoryCRUD";

import { useNotify } from "ra-core";

import {
  filterAisles,
  setInventoryAisleList,
} from "../../../utils/locationUtils";
import { logError } from "../../../utils/appUtils";
import { updateExceptionQuantity } from "../../../utils/utils";
import { InboundState, UserType } from "../../../utils/constants";

const initState = {
  placedShipments: [],
  currentInventory: {},
  currentShipment: {},
  mode: "LIST_SHIPMENTS",
  errors: {},
  notes: {},
  selectedAisle: null,
  selectedLocation: null,
  selectedInventoryItem: { quantityOnHand: 1 },
  inventoryItemsMap: {},
  isContainerNumberValidated: false,
  showCapacityDisplay: false,
  bayList: [],
  displayState: "INVENTORY_ITEMS",
  disableSelection: false,
  searchInventoryItemsMap: {},
  showInventoryQuantity: false,
  loading: false,
};

const InboundContext = createContext(initState);

export const InboundProvider = React.memo(({ children }) => {
  const [state, dispatch] = useReducer(inboundReducer, initState);
  const notify = useNotify();

  const getAisles = async (currentInventory) => {
    try {
      const zoneId = currentInventory?.zoneId?.trim();
      if (!zoneId) {
        dispatch({ type: "SET_AISLES", payload: [] });
        return [];
      }
      const aislesResponse = await API.graphql(
        graphqlOperation(aisleByActiveByZoneBySortKey, {
          zoneId,
          activeSortKey: { beginsWith: { active: "true" } },
          limit: 300,
        }),
      );
      const aisles = filterAisles(
        aislesResponse.data.aisleByActiveByZoneBySortKey.items,
        currentInventory,
      );
      dispatch({ type: "SET_AISLES", payload: aisles });
      return aisles;
    } catch (err) {
      logError(
        "processInboundShipments:InboundAisleMap:getAisles",
        err,
        notify,
      );
      return [];
    }
  };

  const saveInventory = async (inventory, quantityReceived) => {
    debugger;
    inventory.quantityReceived = quantityReceived;
    setInventoryAisleList(inventory);
    updateExceptionQuantity(inventory);
    const toUpdateInventory = { ...inventory };
    toUpdateInventory.productId = toUpdateInventory.productId || "";

    return performUpdateInventoryMini(toUpdateInventory);
  };

  const getShipments = async () => {
    debugger;
    let response = await API.graphql(
      graphqlOperation(inboundShipmentByStateByRailcarReduced, {
        reloadYardId: window.appUser?.reloadYardId,
        stateRailCarNumber: { beginsWith: { state: "PROCESS" } },
        limit: 100,
      }),
    );

    debugger;
    let data = response.data.inboundShipmentByStateByRailcar.items;

    if (window.appUser.type !== UserType.CREW) {
      response = await API.graphql(
        graphqlOperation(inboundShipmentByStateByRailcarReduced, {
          reloadYardId: window.appUser?.reloadYardId,
          stateRailCarNumber: { beginsWith: { state: "APPROVE" } },
          limit: 100,
        }),
      );
      if (response.data.inboundShipmentByStateByRailcar.items.length > 0) {
        data = [
          ...data,
          ...response.data.inboundShipmentByStateByRailcar.items,
        ];
      }
    }

    // Drop PROCESS_INVENTORY_REVIEW rows where unloadedBy is the current user, so those
    // shipments are not listed back to the person who already unloaded them.
    // This is to support secondary review by a different user.
    // Also Drop SIT inbound rows
    data = data.filter(
      (inbound) =>
        !(
          inbound.state === InboundState.PROCESS_INVENTORY_REVIEW &&
          inbound.unloadedBy === window.appUser.fullName
        ) && !inbound.sit,
    );
    data.sort((a, b) => a.placedDateTime.localeCompare(b.placedDateTime));
    return data;
  };

  const getShipment = async (match) => {
    const response = await API.graphql(
      graphqlOperation(getInboundShipmentMobile, { id: match.params.id }),
    );
    const inboundShipment = response.data.getInboundShipment;
    return inboundShipment;
  };

  const saveShipment = async (toUpdateShipment) => {
    toUpdateShipment = { ...toUpdateShipment };

    let response = await performUpdateInbound(toUpdateShipment);
    dispatch({
      type: "UPDATE_CURRENT_SHIPMENT",
      payload: response.data.updateInboundShipment,
    });
    debugger;
  };

  return (
    <InboundContext.Provider
      value={{
        state,
        dispatch,
        getShipments,
        getShipment,
        getAisles,
        saveInventory,
        saveShipment,
        notify,
      }}
    >
      {children}
    </InboundContext.Provider>
  );
});

export const useInboundContext = () => useContext(InboundContext);
